import { TGetMasterListResDto } from "@/api/services/admin/master-data/dtos/get-master-list.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchMasterDataListApi = async (): Promise<TGetMasterListResDto> => {
  const rs = await clientApi.get<TGetMasterListResDto>("/master");
  return rs.data;
};

export const useGetMasterDataList = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.MASTER_DATA.FETCH_LIST],
    queryFn: async () => {
      const rs = await fetchMasterDataListApi();
      return rs.data;
    },
  });
};
